import React, { useContext, useState, useEffect } from "react";
import axios from "axios";

import {
  Dropdown,
  Combobox,
  Icon,
  IconSettings,
} from "@salesforce/design-system-react";
import { useHistory } from "react-router-dom";

import { AppContext } from "../context/appContext";
import { MessagesContext } from "../context/messagesContext";

const FindObject = ({ initSearch }) => {
  const [inputValue, setInputValue] = useState("");
  const [manualSearch, setManualSearch] = useState(false);
  const [selection, setSelection] = useState([]);
  const [matches, setMatches] = useState([]);
  const [subheadings, setSubheadings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const { jwt, formMenuOptions } = useContext(AppContext);
  const { displaySearchResult, displayNewPluginForm, message } = useContext(
    MessagesContext
  );

  const history = useHistory();

  const matchesWithIcon = matches.map((elem) => ({
    ...elem,
    ...{
      icon: (
        <Icon
          assistiveText={{ label: "Account" }}
          category="standard"
          name={elem.type}
        />
      ),
    },
  }));

  const gotoLink = (selected) => {
    switch (selected.type) {
      case "internal-link":
        console.log("INTERNAL LINK CALL");
        history.push(`/${selected.value}`);
        break;
      case "external-link":
        console.log("EXTERNAL LINK CALL");
        let url = window.location.href;
        let arr = url.split("/");
        let goToUrl = arr[0] + "//" + arr[2] + selected.href;
        switch (selected.target) {
          case "_blank":
            // new tab
            window.open(goToUrl, "_blank");
            break;
          default:
            window.location = goToUrl;
            break;
        }
        break;
      default:
        console.log("ERROR: Should not get here");
        break;
    }
  };

  const searchSalesforce = async () => {
    // setIsError(false);
    if (inputValue.length <= 1) {
      return;
    }
    console.log("inputValue", inputValue);
    setIsLoading(true);
    let message_id;
    if (!manualSearch && message) {
      message_id = message.id
    }
    try {
      const result = await axios({
        method: "post",
        url: "/salesforce/api/search",
        data: {
          jwt: jwt,
          terms: inputValue,
          message_id
        },
      });
      console.log("Matches", result);
      setSubheadings(result.data.subheadings);
      setMatches(result.data.matches);
    } catch (error) {
      console.log(error);
      // setIsError(true)
    }
    setIsLoading(false);
  };

  useEffect(() => {
    setInputValue(initSearch);
  }, []);

  useEffect(() => {
    searchSalesforce();
    setIsOpen(inputValue.length > 0);
  }, [inputValue]);

  return (
    <IconSettings iconPath="/icons">
      <div className="slds-grid">
        <div className="slds-grow">
          <Combobox
            events={{
              onChange: (event, { value }) => {
                console.log("onChange", event, value);
                setManualSearch(true);
                setInputValue(value);
              },
              onRequestRemoveSelectedOption: (event, data) => {
                console.log("onRequestRemoveSelectedOption", event, data);
              },
              onSubmit: (event, { value }) => {
                console.log("onSubmit", event, value);
              },
              onSelect: (event, data) => {
                console.log("onSelect", event, data);
                // setSelection(data.selection)
                console.log("DATA SELECTED", data.selection[0]);
                setIsOpen(false);
                displaySearchResult(
                  data.selection[0].id,
                  data.selection[0].type
                );
              },
              onFocus: (event, data) => {
                setIsOpen(true);
              },
              onBlur: (event, data) => {
                setIsOpen(false);
              },
            }}
            labels={{
              label: "Search Salesforce",
              placeholder: "Search",
            }}
            options={matchesWithIcon}
            variant="inline-listbox"
            selection={selection}
            value={inputValue}
            hasMenuSpinner={isLoading}
            isOpen={isOpen}
          />
        </div>
        <div className="slds-shrink add-object-icon-fix">
          <Dropdown
            assistiveText={{ icon: "More Options" }}
            menuPosition="overflowBoundaryElement"
            iconCategory="utility"
            iconName="add"
            iconVariant="border-filled"
            onSelect={(value) => {
              console.log("selected: ", value);
              displayNewPluginForm(value.id);
            }}
            options={formMenuOptions}
          />
        </div>
        <div className="slds-shrink add-object-icon-fix">
          <Dropdown
            assistiveText={{ icon: "More Options" }}
            menuPosition="overflowBoundaryElement"
            iconCategory="utility"
            iconName="threedots"
            iconVariant="border-filled"
            onSelect={(selected) => {
              console.log("selected: ", selected);
              gotoLink(selected);
            }}
            options={[
              {
                type: "external-link",
                label: "Help",
                href: "/help",
                target: "_blank",
              },
              { type: "internal-link", label: "Settings", value: "settings" },
              {
                type: "external-link",
                label: "Developer",
                href: "/developer",
                target: "_blank",
              },
              {
                type: "external-link",
                label: "Disconnect",
                href: `/hootsuite/salesforce/disconnect?jwt=${jwt}`,
                target: "_self",
              },
            ]}
          />
        </div>
      </div>
    </IconSettings>
  );
};

export default FindObject;
